const commonModule = {
  confirm: "Confirm",
  cancel: "Cancel",
  home: "Home",
  search: "Search",
  order: "Order list",
  coupon: "Coupon list",
  user: "My",
  save: "Save",
  isDelete: "Do you want to delete it?",
  isCancel: "Do you want to cancel it?",
  addSuccess: "Successfully added",
  cancelSuccess: "Successfully canceled",
  add: "Added",
  delete: "Delete",
  submit: "Submit",
  emailFormat: "Email format error",
  example: "Example",
  min: "minute",
  noContent: "No data",
  privateBrowse:"The current mode is non-trace mode. Please turn off the non-trace mode to ensure the normal use of the function",
  back: "Back",
  detail: "Detail",
  store: "Store",
  amount: "Amount",
  loading: "Loading...",
  bn: "ID",
  goHome: "goHome",
  desc1:"Tickets on sale",
  agree:"Please agree to the Privacy policy",
  card:"Select a credit card",
  point_list:"Point List",
  invoice:"Please fill in the content",
  jpPhone:"Japan +81",
  cnPhone:"China +86",
  krPhone:"Korea +82",
  hkPhone:"HK +852",
  moPhone:"Macau +853",
  twPhone:"Taiwan +886",
  useNum:"Use Num",
  useSuccess:"Successfully used",
  isUse:"Should I use it?",
  couponOrder:"Order number",
  couponCount1:"Number of vouchers available",
  couponCount2:"Number of vouchers used",
  couponCount3:"Number of expired notes",
  couponCount4:"Number of vouchers obtained",
  couponTime:"Gain time",
  couponShop:"Shop name",
  couponAddr:"Address",
  couponStatus1:"Not Use",
  couponStatus2:"Partial use",
  couponStatus3:"Use up",
  couponStatus4:"Expired",
  close:"Close",
  comment: "Comment",
  copy: "copy",
  copySuccess: "copy success",
  copyFailed: "copy failed",
};

export default commonModule;
